export enum Whitelist {
  ACTION_HOLDBACK = 'cc-enable-action-holdbacks',
  AUDIENCE_DASHBOARD_DEV = 'audience-dashboard-dev', // generic whitelist for ISAU features under development.
  BETA_FEATURES = 'cc-enable-beta-features',
  CAMPAIGN_VALIDATION = 'campaign-validation',
  SINGLE_MESSAGE_CAMPAIGN = 'single-message-campaign',
  CAMPAIGN_K8S_API = 'campaign-k8s-api',
  CAMPAIGNS_OVERVIEW = 'new-overview',
  CONTENT_FORM = 'cc-content-form',
  CUSTOM_UNSUBSCRIBE_PAGE = 'custom-unsubscribe-page',
  DELAY_OVERRIDES = 'cc-enable-delay-overrides',
  DISABLE_CLASSIC_CAMPAIGN_ANALYTICS = 'disable-classic-campaign-analytics',
  IMPERSONATION_VALUES_DEV = 'impersonation-values-dev',
  DYNAMIC_EMAIL_CONTENT = 'email-templates-dynamic-content',
  EXTERNAL_AUDIENCES = 'external-audiences',
  EMAIL_CATEGORY = 'email-category',
  EVENT_PARAMETER_UI = 'event-parameter-ui',
  HIGHER_RECENT_OCCURRENCES_LIMIT = 'incr-occurrences-limit',
  IMMEDIATE_TOP_LEVEL_IN_APP = 'cc-immediate-top-level-in-app',
  LABELS = 'cc-labels',
  LIMIT_TO_SEGMENTS = 'limit-to-segments',
  NEW_TEAM_MANAGEMENT = 'new-team-management',
  NEW_SETTINGS = 'new-settings',
  RECENT_OCCURRENCES = 'recent-occurrences',
  RECURRING_HOURLY = 'cc-recurring-hourly',
  STANDALONE_PREVIEW = 'standalone-preview',
  SECONDARY_NAVIGATION = 'secondary-navigation',
  SECURE_LINKED_DATA = 'secure-linked-data',
  TOP_NAVIGATION = 'top-navigation',
  SEGMENTATION_API_COMPATIBILITY = 'segmentation-api-compatibility',
  DASHBOARD_NOTIFICATIONS = 'dashboard-notifications',
  REDSHIFT_DATA_EXPORT = 'export-data-redshift-csv'
}
